import { Component, ViewChild } from "@angular/core";
import { BaseEntity, BaseState, GenericListEntity, BaseEntitiesResponse, Notification, NotificationListParams, BaseDataResponse } from '@base/entities/BaseEntities';
import { BasePageComponent } from '@base/component/BasePageComponent';
import { ServiceBagService, ServiceBagServices } from '@base/component/ServiceBag';
import { DataSourceCustomAction } from "@base/datalayer/BaseDataSources";
import { NotificationEndpoint } from "@core/endpoints/notification.endpoint";
import { EnumNotificationDeliveryOptions } from "@m4u-angular/core/framework/sysenums.enum";
import { DataLoadOptions } from "@m4u-angular/base/datalayer/DataLoadOptions";
import { NotificationGridComponent } from "./notification-grid/notificationgrid.component";
import { ToolbarSettings } from '@m4u-angular/base/classes/BaseClasses';
import { EmailHistoryGridComponent } from './notification-grid/email-history-grid/email-history-grid.component';
import { SmsHistoryGridComponent } from './notification-grid/sms-history-grid/sms-history-grid.component';
import { PushMessageHistoryGridComponent } from './notification-grid/push-message-history-grid/push-message-history-grid.component';

class State extends BaseState {
    SearchAddress: string;
    SearchUntilDate: Date;
    SearchFromDate: Date;
    SearchTemplate: string;
    Templates: GenericListEntity[];
    CurrentTabIndex: number = 0;
    CurrentDeliveryOption: EnumNotificationDeliveryOptions;
    IsTabsVisible = false;
    RelevantNotificationTypes: any[] = [];
    IsNoData = false;
}

@Component({
    providers: ServiceBagServices,
    selector: 'm4u-notificationshistory',
    templateUrl: './notificationshistory.component.html',
    styleUrls: ['./notificationshistory.component.scss']
})
export class NotificationsHistoryComponent extends BasePageComponent<BaseEntity, State>
{
    @ViewChild('emailGrid') public emailGrid: EmailHistoryGridComponent;
    @ViewChild('smsGrid') public smsGrid: SmsHistoryGridComponent;
    @ViewChild('pushMessageGrid') public pushMessageGrid: PushMessageHistoryGridComponent;
    @ViewChild('whatsAppGrid') public whatsAppGrid: SmsHistoryGridComponent;
    @ViewChild(NotificationGridComponent) public grid: NotificationGridComponent;

    constructor(A: ServiceBagService, private notificationEndpoint: NotificationEndpoint) {
        super(A, 'NotificationsHistoryComponent', Notification, State);
    }

    override OnInitDataSources() {
        this.Do(this.notificationEndpoint.GetNotificationsTemplates(), false, (response: BaseEntitiesResponse<GenericListEntity>) => {
            this.State.Templates = response.Entities;
        });

        this.Do(this.notificationEndpoint.GetRelevantDeliveryOptions(), false, (response: BaseDataResponse<EnumNotificationDeliveryOptions[]>) => {
            this.State.RelevantNotificationTypes = this.LIST('NotificationTypes').filter(x => response.Data.some(y => y === x.Value));
            if (response.Data.length === 0) {
                this.State.IsNoData = true;
                return;
            }

            this.State.IsTabsVisible = response.Data.length > 1;
            this.State.CurrentDeliveryOption = response.Data[0];

            this.LoadDataSource();
        });
    }

    //Load the report
    LoadDataSource() {
        if (!this.State.CurrentDeliveryOption) return;

        const params = new NotificationListParams();
        params.DeliveryOption = this.State.CurrentDeliveryOption;
        params.Address = this.State.SearchAddress;
        params.UntilDate = this.State.SearchUntilDate;
        params.FromDate = this.State.SearchFromDate;
        params.Template = this.State.SearchTemplate;

        this.DataSources['Notifications'] = new DataSourceCustomAction((options: DataLoadOptions) => this.notificationEndpoint.GetNotificationsReport(params, options),
            undefined, undefined, false);
    }

    OnNavigate(e) {
        this.Navigate(["/pages/general/notificationview", e.data.EntryID]);
    }

    OnNavigateCard(e) {
        this.Navigate(["/pages/general/notificationview", e.EntryID]);
    }

    override OnGetToolbarSettings() {
        return {
            IsAllowFilter: true,
            IsAllowExport: true,
            GridExtender: () => this.GetGridExtender()
        } as ToolbarSettings;
    }

    private GetGridExtender = () => {
        switch (this.State.CurrentDeliveryOption) {
            case EnumNotificationDeliveryOptions.Email: return this.emailGrid?.G;
            case EnumNotificationDeliveryOptions.Phone: return this.smsGrid?.G;
            case EnumNotificationDeliveryOptions.PushMessage: return this.pushMessageGrid?.G;
            case EnumNotificationDeliveryOptions.WhatsApp: return this.whatsAppGrid?.G;
            default: return this.emailGrid?.G;
        }
    }

    override OnApplyFilter() {
        this.LoadDataSource();
    }

    override OnClearFilter() {
        this.State.SearchAddress = this.State.SearchFromDate = this.State.SearchUntilDate = this.State.SearchTemplate = undefined;
        this.LoadDataSource();
    }

    OnTabChanged(event) {
        this.State.CurrentTabIndex = event.itemIndex;
        this.State.CurrentDeliveryOption = event.itemData.Value;
        this.LoadDataSource();

        setTimeout(() => this.ReloadToolbar());
    }
}
